/// <reference path="../../../context/loadercontext..js" />
import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import AlertContext from '../../GlobalComponents/Alert/contexts/alertContext';
import Select from 'react-select';
import Observacion from '../../CVForm/Steps/Observacion/index';
//import global components
import { Modal, SideBar, Table } from '../../../imports';
import AddProcessModal from './AgregarProceso';  // Import the AddTechModal component
//import services
import { ObtenerPorVacanteUsuario, ObtenerProcesosCompleto, AgregarProcesos, CambiarPrioridad, EditarProcesoPersona } from '../../../servicios/ServicioProcesos';

import { ObtenerUsuarios } from '../../../servicios/ServicioUsuario';
import { ObtenerEstadosCompleto,ObtenerEstadosVacantesCompleto } from '../../../servicios/ServicioEstados';
import { ObtenerVacantesCompleto } from '../../../servicios/ServicioVacante';




import {
    UserIcon,
    IdentificationIcon,
    MapPinIcon,
    PhoneIcon,
    EnvelopeIcon,
    LinkIcon,
    PlusCircleIcon, FunnelIcon, XMarkIcon, PencilIcon
} from '@heroicons/react/24/outline';
import { useLoader } from '../../../context/LoaderContext.';

export default function Catalogos() {

    const [nomCompleto, setNomCompleto] = useState('');
    const { showLoader, hideLoader } = useLoader();
    const [identificacion, setIdentificacion] = useState('');
    const [telefono, setTelefono] = useState('');
    const [correo, setCorreo] = useState('');
    const [lugarResidencia, setLugarResidencia] = useState('');
    const [linkedin, setLinkedin] = useState('');
    const [estado, setEstado] = useState('');
    const [idPorceso, setIdProceso] = useState('');
    const [especialidad, setEspecialidad] = useState('');
    const [showProcess, setShowProcess] = useState(false);

    //list to save and send data to table
    const [listVacantes, setListVacantes] = useState([]);
    const [listUsuarios, setlistUsuarios] = useState([]);
    const [listEstados, setListEstados] = useState([]);
    const [listEstadosVacantes, setListEstadosVacantes] = useState([]);
    const [listProcesos, setListProcesos] = useState([]);
    const [isSearchable, setIsSearchable] = useState(true);
    const [listVacantesEditar, setListVacantesEditar] = useState([]);

    //use alert context
    const alertCtx = useContext(AlertContext);

    //use modal and show for add
    const [showAddModal, setShowAddModal] = useState(false);

    //use modal and show for view
    const [showViewModal, setShowViewModal] = useState(false);
    const jsonUsuario = sessionStorage.getItem("USER_DATA");
    const usuario = JSON.parse(jsonUsuario);
    const [IdFromView, setIdFromView] = useState(null);



    //use to get state from colums
    const [stateTech, setStateTech] = useState(null);
    const [isEstadoDisabled, setIsEstadoDisabled] = useState(false); 

    const handleVacanteChange = (event) => {
        setSelectedVacanteEditar(event);

        if (event?.value !== null) {
           
            setIsEstadoDisabled(true);
            setSelectedEstado(null);
        } else {
            setIsEstadoDisabled(false);
        }
    };


    async function updatePrioridad(id, direccion) {

        const data = {
            IdProcesos: id,
            Direccion: direccion
        }
        const response = await CambiarPrioridad(data);

        if (response.indicador !== 1) {
            alertCtx.error(response.mensaje);
        }

        //getprocesos();
        filtrar();
    };

    //async function UpdateProcesoPersona(idProceso, idVacante, idEstado) {

    //    const data = {
    //        IdProcesos: idProceso,
    //        IdVacante: idVacante ?? 0,
    //        IdEstado: idEstado
    //    }
    //    const response = await EditarProcesoPersona(data);
    //}
    const UpdateProcesoPersona = async (idProceso, idVacante, idEstado) => {
        const data = {
            IdProcesos: idProceso,
            IdVacante: idVacante ?? 0,
            usuarioModificación: usuario.Correo,
            IdEstado: idEstado
        }
        showLoader();
        const response = await EditarProcesoPersona(data);
        hideLoader();

        if (response.indicador === 0) {
            await getTechnologies()
            alertCtx.success(response.mensaje);
            setSelectedVacante({ value: -1, label: "--Seleccione una vacante--" });
            setShowViewModal(false);
        } else {
            alertCtx.error(response.mensaje);
        }
    }
         
    //declare register to form
    //use react hook form to get values and make validations
    const { register, getValues, setValue, handleSubmit, formState } = useForm({
        mode: 'all',
        defaultValues: {
            descripcion: ''
        }
    });

    const { errors } = formState;

    async function getTechnologies() {
        showLoader();
        const response = await ObtenerVacantesCompleto();
        hideLoader();
        setListVacantes(response);
        setListVacantesEditar(response);
    }

    async function getprocesos() {
        const response = await ObtenerProcesosCompleto();
        setListProcesos(response);
    }

    async function getUsuarios() {
        const response = await ObtenerUsuarios();
        setlistUsuarios(response);
    }

    async function getEstados() {
        const response = await ObtenerEstadosCompleto();
        setListEstados(response);
    }

    async function getEstadosVacantes() {
        const response = await ObtenerEstadosVacantesCompleto();
        console.log(response)
        setListEstadosVacantes(response);
    }

    const [selectedVacante, setSelectedVacante] = useState({ value: null, label: "--Seleccione una vacante--" });
    const [selectedVacanteActual, setSelectedVacanteActual] = useState(null);
    const [selectedVacanteEditar, setSelectedVacanteEditar] = useState({ value: null, label: "--Seleccione una vacante--" });
    const [selectedUsuario, setSelectedUsuario] = useState({ value: null, label: "--Seleccione un usuario--" });
    const [selectedEstado, setSelectedEstado] = useState(null);

    useState(() => {
        showLoader();
        getTechnologies();
        getUsuarios();
        getEstados();
        getEstadosVacantes();
        hideLoader();
        //getprocesos();
    }, [])

    useEffect(() => {
        if (selectedVacante && selectedVacante.value !== null) {
            filtrar();
        }
    }, [showAddModal, showViewModal, stateTech, selectedVacante])

    const optionslistVacantes = listVacantes?.map(option => ({
        value: option.idVacante,
        label: option.descripcion
    }));
    const optionslistVacantesEditar = listVacantesEditar?.map(option => ({
        value: option.idVacante,
        label: option.descripcion
    }));

    const optionslistUsuarios = listUsuarios
        .map(option => ({
            value: option.idPersona,
            label: option.nombres
        }));

    const optionslistEstado = listEstados?.map(option => ({
        value: option.idEstado,
        label: option.descripcion
    }));

    const optionslistEstadoVacantes = listEstadosVacantes?.map(option => ({
        value: option.idEstado,
        label: option.descripcion
    }));

    const EstadoSeleccionado = () => {
        const IdEstado = selectedEstado ? selectedEstado.value : 0;
        return IdEstado; // Retorna el valor
    };

    

    async function filtrar() {
        if (selectedVacante.value) {
            const data = {
                vacante: selectedVacante.value != null ? selectedVacante.value : 0,
                usuario:  0
            }
            const response = await ObtenerPorVacanteUsuario(data);
            setListProcesos(response);

        } else {
            //alertCtx.error("Debe seleccionar al menos una vacante");
            setListProcesos([]);
        }

    };




    //**change this colums with entities names or need data**
    const columns = [

        {
            name: 'Identificación',
            selector: row => row?.identificacion,
        },
        {
            name: 'Nombre',
            selector: row => row?.nombres,
        },
        {
            name: "Estado",
            cell: row => {
                let icon = null;
                let color = null;
                console.log(row)
                switch (row.estado) {
                    case "Contratado":
                        icon = "✔️";
                        color = "green";
                        break;
                    case "Descartado":
                        icon = "❌";
                        color = "red";
                        break;
                    case "En Proceso":
                        icon = "⌛";
                        color = "blue";
                        break;                
                }
                return (

                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span>{row.estado}</span>
                        <span style={{ color, fontSize: "20px" }}>{icon}</span>                      
                    </div>
                );
            },
            sortable: true,
            
        },
        {
            name: selectedUsuario.value == null ? 'Prioridad' : 'Observacion',
            omit: selectedVacanteActual?.estado === false,
            cell: (row) => (
                selectedUsuario.value == null ? (
                    <div style={{ display: 'grid' }}>
                        {/* Contenido cuando la condición se cumple */}
                        <button
                            type="button"
                            id={row?.idVacante}
                            onClick={() => { updatePrioridad(row?.idProceso, 'up') }}
                            className="rounded-full text-sm w-32 py-2 px-4 border-solid border-2 border-green-700 text-green-700 font-bold m-2 hover:border-gray-200"
                            
                        >
                            ▲
                        </button>
                        <button
                            type="button"
                            id={row?.idVacante}
                            onClick={() => { updatePrioridad(row?.idProceso, 'down') }}
                            className="rounded-full text-sm w-32 py-2 px-4 border-solid border-2 border-red-RS text-red-RS font-bold m-2 hover:border-gray-200"
                            
                        >
                            ▼
                        </button>
                    </div>
                ) : null
            ),
            selector: row => (selectedUsuario.value !== null ? row?.observacion : null),
        },

        {
            name: 'Acciones',
            omit: selectedVacanteActual?.estado === false,
            cell: (row) =>
              
                <button type="button" id={row?.idVacante} onClick={() => { setShowViewModal(true); setIdFromView(row?.idUsuario); setNomCompleto(row?.nombres); setCorreo(row?.correo); setEspecialidad(row?.especialidad); setIdentificacion(row?.identificacion); setTelefono(row?.telefono); setLugarResidencia(row?.lugarResidencia); setLinkedin(row?.linkedIn); setIdProceso(row?.idProceso); setSelectedEstado({ value: row?.idEstado, label: row.estado}); }} className="rounded-full text-sm w-32 py-2 px-4 border-solid border-2 border-black-RS text-black-RS font-bold  m-2 hover:border-gray-200 ">Editar</button>
                    
           
                ,
        }

    ]


    const ViewComponent = () => {
        return (
            <div className="w-full max-w-screen-lg mx-auto">
                {/* Título */}
                <div className="flex flex-col items-center mb-6">
                    <div className="flex items-lefth justify-center text-green-500 mb-2">
                        <PencilIcon className="w-8 h-8 ml-2" />
                    </div>
                    <h1 className="text-2xl font-bold text-center">
                        Editar Postulante {selectedVacante.label}
                    </h1>
                </div>

                {/* Contenido principal */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                    {/* Columna 1: Datos Personales */}
                    <div className="w-full">
                        <h2 className="text-2xl font-bold mb-4">Datos Personales</h2>
                        <div className="flex flex-col space-y-4">
                            {[
                                { Icon: UserIcon, title: "Nombre", content: nomCompleto },
                                { Icon: IdentificationIcon, title: "Identificación", content: identificacion },
                                { Icon: MapPinIcon, title: "Lugar de Residencia", content: lugarResidencia },
                                { Icon: PhoneIcon, title: "Teléfono", content: telefono },
                                { Icon: EnvelopeIcon, title: "Correo", content: correo },
                                { Icon: LinkIcon, title: "LinkedIn", content: linkedin },
                            ].map(({ Icon, title, content }) =>
                                content ? (
                                    <div className="flex items-center gap-4" key={title}>
                                        <Icon className="h-8 w-8 text-white" title={title} />
                                        <p className="text-lg font-medium ">{content}</p>
                                    </div>
                                ) : null
                            )}
                        </div>
                    </div>

                    {/* Columna 2: Actualizar */}
                    <div className="w-full">
                        <h2 className="text-2xl font-bold mb-4">Actualizar</h2>
                        <div className="space-y-4">
                            <div>
                                <label className="block text-lg font-medium mb-2">Estado</label>
                                <Select
                                    isSearchable
                                    id="estado"
                                    name="estado"
                                    onChange={setSelectedEstado}
                                    value={selectedEstado}
                                    options={optionslistEstadoVacantes}
                                    placeholder="--Seleccione un estado--"
                                    className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-2 border-grayDark-RS"
                                    isDisabled={isEstadoDisabled}
                                />
                            </div>
                            <div className="flex justify-center">
                                <button
                                    onClick={() => {
                                        UpdateProcesoPersona(
                                            idPorceso,
                                            selectedVacanteEditar ? selectedVacanteEditar.value : 0,
                                            selectedEstado ? selectedEstado.value : 0
                                        );
                                    }}
                                    className="h-10 bg-green-600 hover:bg-green-700 text-white px-4 rounded transition-colors duration-200"
                                >
                                    Actualizar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Observación */}
                <div className="w-full">
                 
                    <div className="w-full">
                        <Observacion idCurriculum={IdFromView} showProcess={showProcess} />
                    </div>
                </div>
            </div>
        );
    };


    

   


    return (
        <>

            <div className="flex flex-row">
                <div className="md:basis-1/4 xl:basis-1/5 ">
                    <SideBar />
                </div>
                <div className="md:basis-3/4 xl:basis-11/12">
                    <div className="bg-white rounded-lg shadow-lg shadow-slate-400 px-2 py-2  mt-2 m-2 mr-8">

                        <div className="px-2">
                            <div className="z-20 ml-4 mt-1 container w-full max-w-screen-lg">
                                <h1 className="left-0 text-xl font-bold text-black-RS mb-1">Procesos</h1>
                                <div className="col-start-1 col-end-3 ">
                                    <div className="w-auto items-center sm:flex">
                                        {/*<button type="button" onClick={filtrar} className="bg-grayDark-RS hover:bg-primary-700 text-white text-sm  py-2 px-4 rounded inline-flex items-center">*/}
                                        {/*    <span>Filtrar</span>*/}
                                        {/*    <FunnelIcon className="w-8 h-8 ml-2"></FunnelIcon>*/}
                                        {/*</button>*/}
                                        <div style={{ margin: "12px", padding: "8px", width: "300px" }}> {/* Ancho fijo de 300px */}
                                            <div style={{ display: "flex", alignItems: "center" }}>


                                                <Select
                                                    isSearchable={isSearchable}
                                                    id="vacante"
                                                    name="vacante"
                                                    onChange={(event) => {
                                                        setSelectedVacante(event);
                                                        const vacanteSeleccionada = listVacantes.filter(v => v.idVacante === event.value)[0];
                                                        setSelectedVacanteActual(vacanteSeleccionada);
                                                        setSelectedUsuario({ value: null, label: "--Seleccione un usuario--" });
                                                        
                                                    }}
                                                    value={selectedVacante}
                                                    options={[{ value: null, label: "--Seleccione una vacante--" }, ...optionslistVacantes]}
                                                    className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"
                                                    placeholder="--Seleccione una vacante--"
                                                />

                                            </div>

                                        </div>
                                        {/*<div className="w-full m-3 px-2  w-full">*/}
                                        {/*    <div className="relative flex items-center">*/}
                                        {/*        <Select*/}
                                        {/*            isSearchable={isSearchable}*/}
                                        {/*            id="usuario"*/}
                                        {/*            name="usuario"*/}
                                        {/*            onChange={(event) => {*/}
                                        {/*                setSelectedUsuario(event);*/}
                                        {/*                setSelectedVacante({ value: null, label: "--Seleccione una vacante--" });*/}
                                        {/*            }}*/}
                                        {/*            value={selectedUsuario}     */}
                                        {/*            options={[{ value: null, label: "--Seleccione un usuario--" }, ...optionslistUsuarios]}*/}
                                        {/*            className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"*/}
                                        {/*            placeholder="--Seleccione un usuario--"*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        <div className="flex w-auto absolute right-0 mr-4 p-8">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setShowAddModal(!showAddModal);
                                                    setValue("descripcion", "");
                                                }}
                                                className="bg-greenButton hover:bg-primary-700 text-white text-sm py-2 px-4 rounded inline-flex items-center"
                                            >
                                                <span>Agregar</span>
                                                <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="static px-2 mt-2 m-2">
                                <Table columns={columns} title="procesos" filteredItems={""} data={listProcesos} filterBy="nombres"/>
                            </div>
                        </div>


                        <Modal
                            isVisible={showViewModal}
                            onClose={() => { setShowViewModal(false) }}
                            showCloseIcon={false}
                            showFotter={false}
                            handleSubmit={handleSubmit}
                            insideContainer={{
                                className: 'w-full', // Usa w-full para ocupar todo el ancho permitido
                                style: { maxWidth: '1200px', padding: '24px' },
                            }}
                        >
                            {/* Button to close modal */}
                            <div className="flex justify-end m-2">
                                <button
                                    className="cursor-pointer text-black-400 hover:text-gray-600 transition duration-150 ease-in-out rounded ring-2 focus:outline-none ring-gray-600"
                                    onClick={() => setShowViewModal(false)}
                                    aria-label="close modal"
                                    role="button"
                                >
                                    <XMarkIcon className="text-red-RS h-6 w-6" />
                                </button>
                            </div>
                            <ViewComponent />
                        </Modal>
                        {/* Main content */}
                        <div className="flex flex-row">

                            <div className="md:basis-3/4 xl:basis-11/12">
                                {/* Other components like header, filters, etc. */}
                                <AddProcessModal
                                    showAddModal={showAddModal}
                                    setShowAddModal={setShowAddModal}
                                    errors={errors}
                                    optionslistVacantes={optionslistVacantes}
                                    optionslistUsuarios={optionslistUsuarios}
                                    optionslistEstado={optionslistEstado}
                                    filtrar={filtrar}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>
    )
}
